import React from 'react';
import { get, filter, isEmpty } from 'lodash';
import { DateUtil } from 'utils/DateUtil';

const mapBanner = (response, mediaPath) => {
  const venues = response.music_event_venues.map(venue => {
    return extractVenues(venue);
  });
  const genres = response.music_event_genres.map(genre => {
    return extractGenres(genre);
  });
  const title =
    response.music_event_details && response.music_event_details[0].event_name;
  const description =
    response.music_event_details &&
    response.music_event_details[0].event_description;
  const event_poster = `${mediaPath.web}/${response.event_poster}`;
  const poster_mobile = `${mediaPath.mobile}/${response.mobile_image}`;
  const thumbnail = `${mediaPath.thumbnail}/${response.event_poster}`;
  const videoUrl = response.event_video ? response.event_video : null;
  const standing_capacity = get(
    response.music_event_venues[0],
    'restaurant_outlet.standing_capacity',
    ''
  );
  const standing_ticket_price = response.standing_ticket_price;
  const seating_ticket_price = response.seating_ticket_price;

  return {
    title,
    description,
    event_poster,
    poster_mobile,
    thumbnail,
    venues,
    genres,
    videoUrl,
    standing_capacity,
    seating_ticket_price,
    standing_ticket_price,
  };
};

const mapEventArtist = (response, artistMediaPath) => {
  let artist_collection = [];
  response.music_event_artists.map((artist_data, idx) => {
    artist_collection.push(mapArtistData(artist_data, artistMediaPath));
  });
  return artist_collection;
};

const mapArtistData = (artist, artistMediaPath) => {
  let artist_data = artist.artist;
  let videos = [];
  let artistIntro = {
    artist_id: artist.artist_id,
    heading: 'About',
    subHeading: get(artist_data, 'artist_details[0].artist_name', ''),
    artist_image: `${artistMediaPath}Web/${artist_data.artist_picture}`,
    artist_image_mobile: artist_data.artist_mobile_picture
      ? `${artistMediaPath}Mobile/${artist_data.artist_mobile_picture}`
      : `${artistMediaPath}Web/${artist_data.artist_picture}`,
    paragraph: get(artist_data, 'artist_details[0].artist_description', ''),
    paragraphMobile: get(
      artist_data,
      'artist_details[0].artist_mobile_description',
      ''
    ),
    artist_website_url: get(artist_data, 'artist_website', ''),
    artist_button_name: get(artist_data, 'artist_details[0].button_name', ''),
    artist_button_link: get(artist_data, 'artist_details[0].button_link', ''),
    artist_website_label: get(
      artist_data,
      'artist_details[0].website_label',
      ''
    ),
  };

  videos = mapArtistVideos(artist_data.artist_videos);

  return {
    artistIntro,
    videos,
  };
};

const mapArtistVideos = videos_data => {
  if (videos_data.length === 0) return [];
  let videos = [];
  videos_data.map(video_data => {
    videos.push(mapVideoForArtist(video_data));
  });
  return videos;
};

const mapVideoForArtist = video_data => {
  const area = get(video_data, 'area.area_name', '');
  const city = get(video_data, 'city.city_name', '');
  const locationType = video_data.location_type;
  return {
    name: video_data.title,
    description: video_data.description,
    description_mobile: video_data.mobile_description,
    videoUrl: video_data.link,
    videoThumbNail: get(video_data, 'thumbnail_url', ''),
    venue:
      locationType === 'Others'
        ? video_data.other_venue
        : get(video_data, 'restaurant_outlet.outlet_name', ''),
    location: `${area}, ${city}`,
    city: city,
    date: DateUtil.getDisplayDateFromISOString(video_data.event_date),
  };
};

const extractGenres = data => {
  return get(data, 'genre.genre_name', '');
};

const extractVenues = data => {
  const area = get(data, 'area.area_name', '');
  const city = get(data, 'city.city_name', '');
  const locationType = data.location_type;
  const eventDates = data.music_event_dates;
  const name =
    locationType === 'Restaurant'
      ? get(data, 'restaurant_outlet.outlet_name', '')
      : data.other_venue;
  const outlet_id = get(data, 'restaurant_outlet_id', '');

  return {
    location: `${area}, ${city}`,
    locationType,
    eventDates,
    name,
    outlet_id,
  };
};

// single-seater tables of the hyderabad outlet, ordered top to bottom of the layout.
export const HYD_SINGLE_SEATER_TABLES = [98, 97, 96, 95, 94, 93, 92, 91];

const mapOutletSeating = (response, outlet_id) => {
  if (isEmpty(response)) return [];
  let tables = [];
  if(outlet_id === 33){
    response.map(table => {
      tables.push(createBlrOutletSeating(table));
    });
    const firstRow = filterTables(tables, 61, 65);
    const secondRow = filterTables(tables, 51, 55);
    const thirdRow = filterTables(tables, 41, 45);
    const fourthRow = filterTables(tables, 31, 35);
    const fifthRow = filterTables(tables, 21, 25);
    const cornerRow = filterTables(tables, 74, 75);
    return {
      firstRow: firstRow,
      secondRow: secondRow,
      thirdRow: thirdRow,
      fourthRow: fourthRow,
      fifthRow: fifthRow,
      cornerRow: cornerRow,
    };
  }
  
  if(outlet_id === 37) {
    response.map(table => {
      tables.push(createHydOutletSeating(table));
    });
    
    const firstRow = filterTables(tables, 81, 85).reverse();
    const secondRow = filterTables(tables, 71, 75).reverse();
    const thirdRow = filterTables(tables, 61, 65).reverse();
    const fourthRow = filterTables(tables, 51, 55).reverse();
    const fifthRow = filterTables(tables, 41, 45).reverse();
    const sixthRow = filterTables(tables, 31, 35).reverse();
    const seventhRow = filterTables(tables, 21, 25).reverse();
    const cornerRow = tables.filter(t => 
      [7, 99].includes(t.table_number)
    );
    const sideTableNumbers = [6, 5, 4, 2, 1];
    const sideTables = sideTableNumbers
      .map(num => tables.find(t => t.table_number === num))
      .filter(Boolean);
    const singleTables = HYD_SINGLE_SEATER_TABLES
      .map(num => tables.find(t => t.table_number === num))
      .filter(Boolean);

    return {
      firstRow: firstRow,
      secondRow: secondRow,
      thirdRow: thirdRow,
      fourthRow: fourthRow,
      fifthRow: fifthRow,
      sixthRow: sixthRow,
      seventhRow: seventhRow,
      cornerRow: cornerRow,
      sideTables: sideTables,
      singleTables: singleTables
    }
  }

  console.warn('Invalid outlet_id:', outlet_id);
  return {};
};

const createBlrOutletSeating = tableData => {
  const { id, seating_capacity, table_number, zone_id } = tableData;
  let table_className = '';
  if ([21, 31, 41, 51, 61].includes(table_number))
    table_className = 'table-1 table-image';
  if ([22, 32, 42, 52, 62].includes(table_number))
    table_className = 'table-2 table-image';
  if ([23, 33, 43, 53, 63].includes(table_number))
    table_className = 'table-3 table-image';
  if ([24, 34, 44, 54, 64].includes(table_number))
    table_className = 'table-4 table-image';
  if ([25, 35, 45, 55, 65].includes(table_number))
    table_className = 'table-5 table-image';
  if (table_number === 75) table_className = 'corner-table-1 table-image';
  if (table_number === 74) table_className = 'corner-table-2 table-image';
  return {
    id,
    table_number,
    zone_id,
    capacity: seating_capacity,
    booked: false,
    imageSelected: false,
    className: table_className,
  };
};

const createHydOutletSeating = tableData => {
  const { id, seating_capacity, table_number, zone_id } = tableData;
  let table_className = '';

  if ([25, 35, 45, 55, 65, 75, 85].includes(table_number))
    table_className = 'table-1 table-image';
  if ([24, 34, 44, 54, 64, 74, 84].includes(table_number))
    table_className = 'table-2 table-image';
  if ([23, 33, 43, 53, 63, 73, 83].includes(table_number))
    table_className = 'table-3 table-image';
  if ([22, 32, 42, 52, 62, 72, 82].includes(table_number))
    table_className = 'table-4 table-image';
  if ([21, 31, 41, 51, 61, 71, 81].includes(table_number))
    table_className = 'table-5 table-image';
  if (table_number === 7)
    table_className = 'corner-table-1 table-image';
  if (table_number === 99)
    table_className = 'corner-table-2 table-image';
  if ([1, 2, 4, 5, 6].includes(table_number))
    table_className = 'side-table table-image';
  if (HYD_SINGLE_SEATER_TABLES.includes(table_number))
    table_className = 'single-table table-image';

  return {
    id,
    table_number,
    zone_id,
    capacity: seating_capacity,
    booked: false,
    imageSelected: false,
    className: table_className,
  };
};

const filterTables = (tables, initial_number, final_number) => {
  return filter(
    tables,
    tableItem =>
      tableItem.table_number >= initial_number &&
      tableItem.table_number <= final_number
  );
};

export const EventDetails = {
  mapBanner,
  mapEventArtist,
  mapOutletSeating,
};
